import { useState } from "react";
import { HiOutlineSquare3Stack3D } from "react-icons/hi2";
import { PiBathtub } from "react-icons/pi";
import { LuBrickWall } from "react-icons/lu";
import ter1 from './images/terrasse/1.jpg';
import { Fade, Zoom } from "react-awesome-reveal";
import Carousel from "./Carousel";


const views = [
    {
        title: 'Carrelage, Parquet, Faïence',
        subs: [
            "Entrées et couloirs",
            "Salons et séjours",
            "Crédence de cuisine",
            "Mosaïque décorative",
            "Carrelage mural",
            "Cuisines",
            "Chambres",
        ],
        altDescription: "Sol intérieur",
        imgs: [
            "https://i.imghos.co/ktjmVBnh.jpg",
            "https://i.imghos.co/T-WnFBtx.jpg",
            "https://i.imghos.co/XsJtDZSc.jpg",
            "https://i.imghos.co/fowGjeWx.jpg",
            "https://i.imghos.co/-WGAj-Gf.jpg",
            "https://i.imghos.co/n-OhdhYD.jpg",
            "https://i.imghos.co/immGXacG.jpg",
            "https://i.imghos.co/pHlDVUTQ.jpg",
            "https://i.imghos.co/pApUIvtE.jpg",
            "https://i.imghos.co/hYkmXQyJ.jpg",
            "https://i.postimg.cc/636j2dTz/20260213-145847.jpg",
            "https://i.imghos.co/EmhbUSEg.jpg",
            "https://i.imghos.co/cO-IugSD.jpg",
            "https://i.imghos.co/WlNHJoMY.jpg",
            "https://i.imghos.co/fDJfAVcM.jpg",
            "https://i.imghos.co/avVVNndj.jpg",
            "https://i.imghos.co/bGowlnwu.jpg",
            "https://i.imghos.co/ZClmcVbM.jpg",
            "https://i.imghos.co/tfDeEWBV.jpg",
            "https://i.imghos.co/hJQIKdpk.jpg",
            "https://i.imghos.co/IoPkioGx.jpg",
            "https://i.postimg.cc/hPcnCmk9/20230412-111042.jpg",
            "https://i.imghos.co/XpWPCVWB.jpg",
            "https://i.imghos.co/EglGhwgr.jpg",
            "https://i.imghos.co/LvdRFyrD.jpg",
            "https://i.postimg.cc/YSzDCX2Q/20260213-104950.jpg",
            "https://i.imghos.co/QsUJtQGM.jpg",
            "https://i.imghos.co/AVzDpQlj.jpg",
            "https://i.imghos.co/yXDbcWJz.jpg",
            "https://i.imghos.co/rVEVdwtC.jpg",
            "https://i.imghos.co/PwKrdfVz.jpg",
            "https://i.postimg.cc/NMGJ91L4/20260213-105000.jpg",
            "https://i.imghos.co/KSItQnlH.jpg",
            "https://i.imghos.co/wbRNoaJI.jpg",
            "https://i.imghos.co/CXJGhHWk.jpg",
            "https://i.imghos.co/ASlIlWWr.jpg",
            "https://i.imghos.co/sypyE-cm.jpg",
            "https://i.postimg.cc/Lsp0RdSH/20260213-104821.jpg",
            "https://i.imghos.co/cAUhSYPD.jpg",
            "https://i.imghos.co/Cnsqxgch.jpg",
            "https://i.imghos.co/kuMGIYuV.jpg",
            "https://i.postimg.cc/8zWnqpqb/20220929-105043.jpg",
            "https://i.imghos.co/lsazSkvK.jpg",
            "https://i.imghos.co/FlFmYwLH.jpg",
            "https://i.imghos.co/pdGFzFBT.jpg",
            "https://i.postimg.cc/q7TZ0frJ/20220929-105106.jpg",
            "https://i.imghos.co/fmCeNgKz.jpg",
            "https://i.imghos.co/rAqknVMe.jpg",
            "https://i.imghos.co/ZwoJAhTk.jpg",
            "https://i.imghos.co/lD-xFpvS.jpg",
            "https://i.imghos.co/othNomXc.jpg",
            "https://i.postimg.cc/h4pBnLkJ/20260506-142139.jpg",
            "https://i.postimg.cc/dQ4YF2b8/20260507-120640.jpg",
            "https://i.postimg.cc/MpRrh6h0/20220309-171613.jpg",
            "https://i.postimg.cc/Sx8twSwf/20220929-105052.jpg",
            "https://i.postimg.cc/tgjmy0bR/20260213-104848.jpg",
            "https://i.postimg.cc/LX4CYzhC/20260213-105301.jpg",
            "https://i.postimg.cc/FRPPj7JG/20260213-145852.jpg",
            "https://i.postimg.cc/W399MhJy/20260409-103646.jpg",
            
        ]

    },
    {
        title: 'Salle de Bain',
        subs: [
            "Habillage de baignoire",
            "Douche à l'italienne",
            "Receveurs à carreler",
            "Étanchéité complète",
            "Faïence murale",
        ],
        altDescription: "Salle de bain",
        imgs: [
            "https://i.postimg.cc/cLPJCHzJ/20260418-120819.jpg",
            "https://i.postimg.cc/Hx9W6tkp/20260418-120940.jpg",
            "https://i.imghos.co/MnWrHmJO.jpg",
            "https://i.postimg.cc/3J7mrLG8/20231219-113907.jpg",
            "https://i.postimg.cc/ydHYhGsk/20260418-120857.jpg",
            "https://i.postimg.cc/Sx9nWCCt/9fa5f03d-ce27-4887-b9b0-5f72f1aa7fd2.jpg",
            "https://i.imghos.co/BpujUzQq.jpg",
            "https://i.postimg.cc/vT8Yk64n/20260418-121257.jpg",
            "https://i.imghos.co/rKsugfoN.jpg",
            "https://i.postimg.cc/j54qMhSR/20260418-120847.jpg",
            "https://i.imghos.co/sRcOPzhs.jpg",
            "https://i.imghos.co/ZEWsSVvH.jpg",
            "https://i.imghos.co/lGFcacbd.jpg", 
            "https://i.imghos.co/-dGaqLhm.jpg",
            "https://i.imghos.co/aJCLzbgG.jpg",
            "https://i.imghos.co/-RbPUAzX.jpg",
            "https://i.imghos.co/XFVkarPo.jpg",
            "https://i.postimg.cc/5ymHFVCR/20240215-111247.jpg",
            "https://i.postimg.cc/gjKw6WZf/20240215-111257.jpg",
            "https://i.postimg.cc/Y9Kjn9Ny/20250423-112702.jpg",
            "https://i.postimg.cc/tTQ7STdw/20250814-134526.jpg",
            "https://i.postimg.cc/wTqK5pNy/20220727-185321.jpg",
            "https://i.postimg.cc/c44C5PYx/20250814-134531.jpg",
            "https://i.postimg.cc/MpnTzRdY/20260407-140849.jpg",
            "https://i.postimg.cc/2S16Cv2G/20260407-140925.jpg",
            "https://i.postimg.cc/C1gLC2YQ/20260418-120829.jpg",
            "https://i.postimg.cc/NFgB4bW1/20260506-104545.jpg",
            "https://i.postimg.cc/WpXvVGBd/20260506-104556.jpg",
            "https://i.postimg.cc/R0YW8ycq/5949729376939660209.jpg",
            "https://i.postimg.cc/N0nKVS1q/5742740637658246037.jpg",
            "https://i.postimg.cc/qBjTrsPq/20260506-104608.jpg",

        ]

    },
    {
        title: 'Aménagements extérieurs',
        subs: [
            "Terrasses carrelées",
            "Balcons et loggias",
            "Entrées de garage",
            "Tours de piscine",
            "Allées piétonnes",
            "Seuils de portes",
            "Tours de maison",
            "Marches d'entrée",
            "Patios",
        ],
        altDescription: "Sol extérieur",
        imgs: [
            "https://i.postimg.cc/Jh9fTKB8/IMG-20260604-161653-(2).jpg",
            "https://i.postimg.cc/Y0jC1dcM/IMG-20260604-161653-(6).jpg",
            "https://i.postimg.cc/CxMSDvbN/IMG-20260604-161653-(1).jpg",
            'https://i.postimg.cc/Y2N536rV/IMG-20260604-161653-(5).jpg',
            "https://i.postimg.cc/VvBP0Mvm/20260601-152821.jpg",
            'https://i.postimg.cc/6qNyNdgc/20260520-104548.jpg',
            "https://i.postimg.cc/659D18Tw/IMG-20260604-161653.jpg",
            'https://i.postimg.cc/hG7800Bf/Resized-IMG-4103-1780339093517.jpg',
            ter1,
            "https://i.postimg.cc/L8G0WKq6/20230711-094457.jpg",
            "https://i.postimg.cc/4dQLnYWJ/20230711-094515.jpg",
            "https://i.postimg.cc/zBFt3yxB/20230711-105122.jpg",
            "https://i.postimg.cc/mkZd9Tnb/20230711-105130.jpg",
            "https://i.postimg.cc/4y8WbrCp/20230712-102023.jpg",
            "https://i.postimg.cc/BQ6YQQDB/20230712-125153.jpg",
            "https://i.postimg.cc/zDp2rRL2/20230712-125210.jpg",
            "https://i.postimg.cc/Qxt4xx52/20230712-125238.jpg",
            "https://i.postimg.cc/zB8pmJ8n/20240913-102515.jpg",  
            "https://i.postimg.cc/0jHCJDmd/20240920-150522.jpg",  
            "https://i.postimg.cc/9Fnx45Yh/20240607-104434.jpg",
            "https://i.postimg.cc/sDNnBd4f/20240607-111534.jpg",
            "https://i.postimg.cc/m25dcfyg/20240607-111544.jpg",
            "https://i.postimg.cc/vHNP1Ftg/20240612-092925.jpg",
            "https://i.postimg.cc/8zfZMKZX/20240613-121649.jpg",
            "https://i.postimg.cc/wBK0VXrn/20240814-115213.jpg",
            "https://i.postimg.cc/wBK0VXrC/20240814-115301.jpg",
            "https://i.postimg.cc/wBK0VXP1/20240814-115310.jpg",
            "https://i.postimg.cc/0NpZH6RC/20240814-115317.jpg",
            "https://i.postimg.cc/LXDD2rsY/20240913-102522.jpg",
            "https://i.postimg.cc/cCJmHXKY/20240914-112946.jpg",
            "https://i.postimg.cc/6qQ03Y7n/20240914-112953.jpg",
            "https://i.postimg.cc/PJFM8YZQ/20240920-150538.jpg",
            "https://i.postimg.cc/kMjsZ3Zp/20240920-150613.jpg",
            "https://i.postimg.cc/9FrbHg5g/20240920-150619.jpg",
            "https://i.postimg.cc/hPfsRZRc/20240920-150633.jpg",
            "https://i.postimg.cc/28VGN9Nz/20240920-150640.jpg",
            "https://i.postimg.cc/hP6rD8K1/20250628-164007.jpg",
            "https://i.postimg.cc/hP6rD8KV/20250628-165755.jpg",
            "https://i.postimg.cc/BnFCX8vh/20250909-155600.jpg",
            "https://i.postimg.cc/x1mPckdP/20250909-155616.jpg",
            "https://i.postimg.cc/13FKfgtZ/20250909-155648.jpg",

        ]

    }
]


function Gallery({isMobile}) {

    const [ currentCategory, goToCategory ] = useState(0);
    
    const classes = (
        isMobile
        ? {
            cat: 'flexy row',
            title: 'smaller nomargin',
        }
        : {
            cat: 'flexy row large',
        }
    );

    return <div className="flex screensize maxHeight100">
        &nbsp;
        <h2 className='text-shadow nomargin'>Mes Réalisations</h2>

        <div className='flex row allwidth spaceevenly'>
            <button key={0} className={`app-button ${currentCategory === 0 ? 'selected' : ''}`} onClick={() => goToCategory(0)}>
                <div className={classes.cat}>
                    <HiOutlineSquare3Stack3D />
                    &nbsp;&nbsp;Revêtement Intérieur
                </div>
            </button>
            <button key={1} className={`app-button ${currentCategory === 1 ? 'selected' : ''}`} onClick={() => goToCategory(1)}>
                <div className={classes.cat}>
                    <PiBathtub />
                    &nbsp;&nbsp;Salle de Bain
                </div>
            </button>
            <button key={2} className={`app-button ${currentCategory === 2 ? 'selected' : ''}`} onClick={() => goToCategory(2)}>
                <div className={classes.cat}>
                    <LuBrickWall />
                    &nbsp;&nbsp;Revêtement Extérieur
                </div>
            </button>
          
        </div>
        <div className="flex flexdot9 width100">
            <div className={`flex ${isMobile ? 'col' : 'row'} width90vw`} style={{maxHeight: '80vh', maxWidth: '90vw'}}>
                <Zoom duration={600} key={`titlezoom${currentCategory}`} className='custom-zoom flex allspace primarybkggradient xxlarge text-shadow flexdot3' style={{borderRadius: isMobile ? '30px' : '30px 0 0 30px', height: '80vh'}}>
                    <Fade delay={500} cascade damping={0.03} key={`titlefade${currentCategory}`}>
                        <div className="allwidth">
                            <h3 className={classes.title}>{ views[currentCategory].title }</h3>  
                            {
                                isMobile
                                ? <div className='small pb1'>
                                    { views[currentCategory].subs?.map((sub, si) => `${sub}, `) }
                                </div>
                                : <ul className='alignleft smaller'>
                                    { views[currentCategory].subs?.map((sub, si) => <li key={`sub${si}`}>{ sub }</li>) }
                                </ul>
                            } 
                        </div>
                    </Fade>
                </Zoom>
    
                <Zoom className='custom-zoom flex flexdot7' key={`carouselzoom${currentCategory}`} duration={600} style={{overflow: 'hidden'}}>
                    <Carousel slides={views[currentCategory].imgs} altDescription={views[currentCategory].altDescription} isMobile={isMobile} />
                </Zoom>
                    
            </div>
        </div>
        
    </div>
}

export default Gallery;